type HeaderValue = string | string[] | undefined

const DEFAULT_HOST = "werz.at"

function pickHeaderValue(value: HeaderValue): string | undefined {
  if (Array.isArray(value)) {
    return value[0]
  }

  return value?.split(",")[0]?.trim()
}

function inferProtocol(host: string, forwardedProto?: string): string {
  if (forwardedProto) {
    return forwardedProto
  }

  return host.includes("localhost") || host.startsWith("127.0.0.1") ? "http" : "https"
}

export function getRequestBaseUrl(req?: { headers?: Record<string, HeaderValue> }): string {
  const host =
    pickHeaderValue(req?.headers?.["x-forwarded-host"]) ??
    pickHeaderValue(req?.headers?.host) ??
    DEFAULT_HOST
  const proto = inferProtocol(host, pickHeaderValue(req?.headers?.["x-forwarded-proto"]))

  return `${proto}://${host}`
}

export function getHeadersBaseUrl(headers: Headers): string {
  const host =
    pickHeaderValue(headers.get("x-forwarded-host") ?? undefined) ??
    pickHeaderValue(headers.get("host") ?? undefined) ??
    DEFAULT_HOST
  const proto = inferProtocol(host, pickHeaderValue(headers.get("x-forwarded-proto") ?? undefined))

  return `${proto}://${host}`
}

export function toAbsoluteUrl(baseUrl: string, path: string): string {
  return new URL(path, `${baseUrl}/`).toString()
}

// Client-side route transitions fetch getServerSideProps via /_next/data requests.
// Social crawlers only ever make full-document requests, so meta-tag work can be
// skipped for these to keep in-app navigations fast.
export function isClientSideNavigation(req?: { url?: string }): boolean {
  return req?.url?.startsWith("/_next/data/") ?? false
}
